import { inject, Injectable } from '@angular/core';
import { PatientDocumentGandalfService } from '@gandalf/services';
import { Observable, Subject } from 'rxjs';
import { PatientDocumentResponse } from '@gandalf/model/patient-document-response';
import { PatientDocumentContentRequest } from '@gandalf/model/patient-document-content-request';
import { PatientFileInfoResponse } from '@gandalf/model/patient-file-info-response';

export interface LetterEditorOpenRequest {
	patientDocumentId: number;
	existingTask: boolean;
}

@Injectable({
	providedIn: 'root',
})
export class LetterEditorDockableModalService {
	private patientDocumentGandalfService = inject(PatientDocumentGandalfService);

	private openRequest = new Subject<LetterEditorOpenRequest>();
	openRequest$ = this.openRequest.asObservable();

	requestOpen(patientDocumentId: number, existingTask: boolean) {
		this.openRequest.next({ patientDocumentId, existingTask });
	}

	/* istanbul ignore next: gandalf */
	getPatientDocument(patientDocumentId): Observable<PatientDocumentResponse> {
		return this.patientDocumentGandalfService.getPatientDocument(patientDocumentId);
	}

	/* istanbul ignore next: gandalf */
	updatePatientDocumentContent(patientDocumentContentRequest: PatientDocumentContentRequest): Observable<void> {
		return this.patientDocumentGandalfService.updatePatientDocumentContent(patientDocumentContentRequest);
	}

	/* istanbul ignore next: gandalf */
	createPatientFileFromPatientDocument(patientDocumentContentRequest: PatientDocumentContentRequest): Observable<PatientFileInfoResponse> {
		return this.patientDocumentGandalfService.createPatientFileFromPatientDocument(patientDocumentContentRequest);
	}
}
